import { InjectionToken } from '@angular/core';

export type FeatureFlags = {
  pathToRegister: boolean;
  showDiscountBanner: boolean;
  redirectAfterRegistration?: boolean;
};

export type UrlsConfig = {
  userAccountUrl: string;
  registrationUrl: string;
  termsUrl: string;
  privacyPolicyUrl: string;
};

export type CaptchaProvider = 'recaptcha' | 'turnstile';

export type AuthContextConfig = UrlsConfig & {
  captchaSiteKey: string;
  turnstileSiteKey?: string;
  captchaProvider: CaptchaProvider;
  googleAuthClientId: string;
  oneTapLoginEnabled?: boolean;
  featureFlags: FeatureFlags;
};

export const AUTH_CONTEXT_CONFIG = new InjectionToken<AuthContextConfig>('AUTH_CONTEXT_CONFIG');

export function provideAuthConfig(config: AuthContextConfig) {
  return { provide: AUTH_CONTEXT_CONFIG, useValue: config };
}
